import { types } from "../types/types";

const initialState = {
  solicitudes: [],
  historialActual: [],
  solicitudActiva: null,
  ultimosMensajes: {},
  loading: false,
  mensajesNoLeidos: 0,
  archivosActuales: [],
  loadingArchivos: false,
  subiendoArchivo: false
};

export const atencionReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.storeAtencion:
      return { ...state, solicitudes: action.payload };
    
    case types.setLoadingAtencion:
      return { ...state, loading: action.payload };
    
    case types.storeHistorialAtencion:
      return { ...state, historialActual: action.payload };
    
    case types.setSolicitudActivaAtencion:
      return { ...state, solicitudActiva: action.payload };
    
    case types.setMensajesNoLeidosAtencion:
      return { ...state, mensajesNoLeidos: action.payload };
    
    case types.addMensajeOptimistaAtencion:
      return { 
        ...state, 
        historialActual: [...state.historialActual, action.payload] 
      };
    
    case types.removeMensajeOptimistaAtencion:
      return { 
        ...state, 
        historialActual: state.historialActual.filter(m => m.proveedorSolicitudHistorialID !== action.payload) 
      };
    
    case types.updateSolicitudEstatusAtencion:
      return {
        ...state,
        solicitudes: state.solicitudes.map(solicitud =>
          solicitud.proveedorSolicitudID === action.payload.solicitudId
            ? { ...solicitud, estatus: action.payload.estatus }
            : solicitud
        )
      };
    
    case types.storeUltimoMensajeAtencion:
      return {
        ...state,
        ultimosMensajes: {
          ...state.ultimosMensajes,
          [action.payload.solicitudId]: action.payload.ultimoMensaje
        }
      };
    
    case types.storeArchivosSolicitud:
      return { ...state, archivosActuales: action.payload };
    
    case types.setLoadingArchivos:
      return { ...state, loadingArchivos: action.payload };
    
    case types.setSubiendoArchivo:
      return { ...state, subiendoArchivo: action.payload };
    
    default:
      return state;
  }
};